import * as styles from "./ComboboxEmpty.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxEmptyProps } from "./Combobox.types";

export function ComboboxEmpty({
  className,
  ...props
}: ComboboxEmptyProps): JSX.Element {
  return (
    <BaseCombobox.Empty
      data-slot="combobox-empty"
      className={clsx(styles.empty, className)}
      {...props}
    />
  );
}
